module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"keywords":"倉庫を貸したい,ウェアエックス,WareX","title":"倉庫スペースを提供したい方へ","description":"使っていない倉庫スペースをそのままにしていませんか？Warexに登録すれば、遊休スペースを活用して新たな収入源にすることが可能です。"}}')
  delete Component.options._Ctor
}
